export default function isJson (item) {
  item = typeof item !== 'string' ? JSON.stringify(item) : item
  try {
    item = JSON.parse(item)
  } catch (e) {
    return false
  }
  return (typeof item === 'object' && item !== null) || false
}



// WEBPACK FOOTER //
// ./src/utils/isJson.js